
import ThruTimeData from "./ThruTimeData";

export default class ThruTimeDataManage {

    thruTimeData = new ThruTimeData();
 
    loadLocationData() {
        this.thruTimeData.loadLocalData();
    }

    saveAllLocationData() {
        this.thruTimeData.saveLocalData();
    }

    openNewLevel(lvId: string) {
        let data = this.thruTimeData.lists.get(lvId);
        if (!data) {
            data = this.thruTimeData.createItem(lvId);
            this.thruTimeData.saveLocalData();
        }
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {
       
    }

}
